import http from "../../axios-config/g-http-metodos";

function getUnidadeByClienteId(clienteId){
    const{ res, erro, requisicao} = http.get(`Cliente/GetUnidadeByClienteId/${clienteId}`)
    return{Unidade :res , erro, requisicao}
}

function getUnicaUnidadeByClienteId(clienteId){
    const{ res, erro, requisicao} = http.get(`Cliente/GetUnicaUnidadeByClienteId/${clienteId}`)
    return{Unidade :res , erro, requisicao}
}

const UnidadeController = {
    getUnidadeByClienteId,
    getUnicaUnidadeByClienteId

  }

  export default UnidadeController
